/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";
import { WorkerProfile } from "./types";

const fetchWorker = async (workerID: string): Promise<WorkerProfile>   =>  {
  const { data } = await apiInputService.get(`/Worker/workerId/${workerID}`);

  return data;
};

export const useWorkerQuery = (workerID: string, options?: any) => {
  return useQuery<WorkerProfile>(["worker", workerID], () => fetchWorker(workerID), {
    cacheTime: 1000 * 10,
    ...options,
  });
};
